import { z } from 'zod'

export const projectSchema = z.object({
  name: z.string().min(1, 'Projektname ist erforderlich'),
  address: z.string().optional(),
  client: z.string().optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  description: z.string().optional(),
  latitude: z.coerce.number().optional(),
  longitude: z.coerce.number().optional(),
  radius: z.coerce.number().optional(),
})

export type ProjectInput = z.infer<typeof projectSchema>
